Ext.define('SA.data.locationsearch.LocationQueryManager', {
    extend: 'SA.data.QueryManager',

    queryCache: {},
    queryList: [],

    text: '',

    buildQuery() {
        if (this.text.length < 3) {
            return null;
        }

        return {
            type: 'location-search',

            censusReleases: Ext.Array.from(this.censusRelease),
            fields: SA.data.LocationsCache.getQueryFields(),
            geographicReleases: this.geographicReleases,
            geographicUnits: this.geographicUnits,
            limit: this.pageSize,
            prefix: this.text,
            start: (this.page - 1) * this.pageSize
        };
    },

    clearGeographicReleases() {
        this.geographicReleases = null;

        this.clearCache();
    },

    onSuccess(response) {
        var results = this.prepareResponse(response);

        SA.data.LocationsCache.add(results);

        this.onResults.call(this.scope, {
            results: results.map(result => SA.data.LocationsCache.canonicalize(result))
        });
    },

    setCensusRelease(censusRelease) {
        this.censusRelease = censusRelease;
    },

    setGeographicReleases(geographicReleases) {
        this.geographicReleases = geographicReleases;

        this.clearCache();
    },

    setGeographicUnits(units) {
        if (units && !Array.isArray(units)) {
            units = [units];
        }

        var oldUnits = this.geographicUnits;

        if (units !== oldUnits && (!units || !oldUnits || units.join(',') !== oldUnits.join(','))) {
            this.geographicUnits = units;

            this.setPage(1);
        }
    },

    setText(text) {
        if (this.text !== text) {
            this.text = text;

            this.setPage(1);
        }
    }
});
